import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable
} from 'react-beautiful-dnd';

import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Grid from '@mui/system/Unstable_Grid';
import { IconButtonWithConfirmation } from '../../../../shared/components/IconButtonWithConfirmation';
import Paper from '@mui/material/Paper';
import React from 'react';
import { TimelineAsset } from '../../../models/LessonComponentContent';
import TimelineEditor from './TimelineEditor';
import { TimelineProps } from './Timeline';
import { cloneDeep } from 'lodash';
import { useLessonEditContext } from '../../../models/LessonEditContext';

export default function TimelineItems(props: TimelineProps) {
  const { component } = props;

  const timelineItems = component?.content.timeline;
  const { handleSettingsChange } = useLessonEditContext();

  const handleChange = (item: TimelineAsset) => {
    const copy = cloneDeep(component);
    const index = copy.content.timeline.findIndex((t) => t.id === item.id);
    copy.content.timeline[index] = item;
    handleSettingsChange(copy);
  };

  const handleItemDelete = (id: string) => {
    const copy = cloneDeep(component);
    const index = copy.content.timeline.findIndex((t) => t.id === id);
    copy.content.timeline.splice(index, 1);
    handleSettingsChange(copy);
  };

  const handleDragEnd = (result: DropResult) => {
    // prevent from destination index outbound error
    if (!result.destination) return;
    const fromIndex = result.source.index;
    const toIndex = result.destination.index;
    const copy = cloneDeep(props.component);
    const movingItem = copy.content.timeline[fromIndex];
    copy.content.timeline.splice(fromIndex, 1);
    copy.content.timeline.splice(toIndex, 0, movingItem);
    handleSettingsChange(copy);
  };

  const getDroppableStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? '#eee' : 'transparent',
    height: '100%'
  });

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="selection-options">
        {(provided1, snapshot1) => (
          <div
            ref={provided1.innerRef}
            style={{
              ...getDroppableStyle(snapshot1.isDraggingOver),
              width: '100%'
            }}
          >
            {timelineItems?.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided2, snapshot2) => (
                  <div ref={provided2.innerRef} {...provided2.draggableProps}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      pb="15px"
                    >
                      <Grid style={{ flex: 11 }}>
                        <Paper
                          elevation={2}
                          style={{ flex: 1 }}
                          {...provided2.dragHandleProps}
                        >
                          <Grid container>
                            <Grid
                              {...provided2.dragHandleProps}
                              style={{ flex: 1, color: 'rgba(0,0,0,0.54)' }}
                              alignSelf="center"
                            >
                              <DragIndicatorIcon />
                            </Grid>
                            <Grid style={{ flex: 11 }}>
                              <TimelineEditor
                                componentkey={component?.componentkey}
                                timelineItem={item}
                                handleChange={handleChange}
                              />
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                      <Grid
                        style={{ flex: 1 }}
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"
                      >
                        <IconButtonWithConfirmation
                          size="small"
                          onConfirm={() => handleItemDelete(item.id)}
                        >
                          <DeleteIcon />
                        </IconButtonWithConfirmation>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </Draggable>
            ))}
            {provided1.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
